// var paywall = require("./lib/paywall");
// setTimeout(() => paywall(12345678), 5000);
require("component-responsive-frame/child");
require("component-leaflet-map");


//get access to Leaflet and the map
var element = document.querySelector("leaflet-map");
var L = element.leaflet;
var map = element.map;

// console.log('hi mom');

//ICH code for popup template if needed----------

// var ich = require("icanhaz");
// var templateFile = require("./_popup.html");
// ich.addTemplate("popup", templateFile);
//
// var onEachFeature = function(feature, layer) {
//   layer.bindPopup(ich.popup(feature.properties))
// };

var markers = [];
var markergroup = L.featureGroup()

window.course.forEach(function(data) {

  var marker = L.marker([data.latitude, data.longitude], {
    icon: L.divIcon({
      className: 'marker'
    })
  });
  var html = `
    <b class="big">${data.Name}</b><br>
    Address: <a href="https://www.google.com/maps/search/?api=1&query=${data.latitude},${data.longitude}" target="_blank" rel="noopener noreferrer"/>${data.Address}, ${data.City}</a><br>
    Hours: ${data.Hours}<br>
    <div class="right"><a href="${data.Website}" target="_blank" rel="noopener noreferrer"/>Website</a></div>
  `;
  marker.bindPopup(html);
  markers.push(marker);
  marker.addTo(markergroup);
});

markergroup.addTo(map);

 // map.scrollWheelZoom.disable();
 map.fitBounds(markergroup.getBounds());

 // map.setView([47.51399709643452, -122.22150450000686], 9);

 // map.setZoom(9);
